/**
 * Created by Kaku.Guo on 2019/6/10.
 */
import React, { useRef, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { connect } from 'react-redux';
import { ModalDialog, Button, getMessage, ReviewItem } from '../index';
import { ReviewDialogActions } from '../../actions';
import ReviewReportContent from './ReviewReportContent';

const mapDispatchToProps = dispatch => {
    return {
        hideReviewDialog: () => dispatch(ReviewDialogActions.hide())
    };
};

const mapStateToProps = (state) => {
    const messages = state.get('localization').get('messageProperties');
    const options = state.get('reviewDialog').toJS();
    return {
        messages,
        options
    };
};

function ReviewReportDialog(props) {
    const { options = {}, messages, hideReviewDialog } = props;
    const { isReportVisible, isLoading, onSave, error, target = {}, type, defaultValue = {}, onPreload, preventSubmit, toConfirmed } = options;
    const { abuseType, content } = defaultValue;
    const prefixCls = 'review-report-dialog';
    const reportRef = useRef(null);

    useEffect(() => {
        if (isReportVisible && onPreload) {
            onPreload();
        }
    }, [isReportVisible]);

    const onSubmit = () => {
        if (onSave) {
            const value = reportRef.current.getValue();
            if (value) {
                onSave(value);
            }
        }
    };

    const isDisabled = !!isLoading;
    const classNames = cn(prefixCls, isDisabled && `${prefixCls}--disabled`);
    let errorMessage = null;
    if (error && error.errorCode) {
        errorMessage = getMessage(messages, error.errorCode);
    }

    const ReportContent = () => (
        <Fragment>
            <div className="content">
                <ReviewItem
                    type={type}
                    className={`${prefixCls}__target`}
                    data={target}
                    isShowReadMore={false}
                />
                <ReviewReportContent
                    ref={reportRef}
                    className={`${prefixCls}__content`}
                    messages={messages}
                    defaultValue={{ abuseType, content }}
                    isDisabled={isDisabled}
                />
            </div>
            <div className="footer">
                <div className="error">{errorMessage}</div>
                <div>
                    {isLoading && (<div className="loading" />)}
                    <Button
                        disabled={isDisabled || preventSubmit}
                        onClick={onSubmit}>
                        {getMessage(messages, 'messages.com.epicgames.plugin.store.asset.reviews.report.dialog.submit')}
                    </Button>
                </div>
            </div>
        </Fragment>);
    
    const ReportConfirm = () => (
        <div className={`${prefixCls}__confirm`}>
            <div>
                <h4>{getMessage(messages, 'messages.com.epicgames.plugin.store.asset.reviews.report.dialog.confirm.content')}</h4>
                <p>{getMessage(messages, 'messages.com.epicgames.plugin.store.asset.reviews.report.dialog.confirm.desc')}</p>
            </div>
            <Button onClick={() => hideReviewDialog()}>
                {getMessage(messages, 'messages.com.epicgames.plugin.store.asset.replies.dialog.confirm')}
            </Button>
        </div>
    );

    return (
        <ModalDialog
            onClose={hideReviewDialog}
            isVisible={!!isReportVisible}
            className={classNames}>
            <div className="header">{getMessage(messages, 'messages.com.epicgames.plugin.store.asset.reviews.report.dialog.header')}</div>
            {
                toConfirmed ? <ReportConfirm /> : <ReportContent />
            }
        </ModalDialog>
    );
}

ReviewReportDialog.propTypes = {
    options: PropTypes.object,
    messages: PropTypes.object,
    hideReviewDialog: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewReportDialog);